import React, { useState, useEffect, useRef } from "react";
import { CircularProgress } from '@material-ui/core';
import './PdfDisplay.css';
import 'react-pdf/dist/cjs/Page/AnnotationLayer.css';
const { Document, Page, pdfjs } = require("react-pdf");
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function AllPages(props) {
  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(null);
  const pdfContainerRef = useRef(null);
  const { pdf } = props;

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  }

  useEffect(() => {
    const updatePageWidth = () => {
      if (pdfContainerRef.current) {
        // Keep the rendered page inside the PDF column so it does not run into
        // the lender logo column and matches the scale used in UAT.
        setPageWidth(pdfContainerRef.current.clientWidth * 0.90);
      }
    };

    updatePageWidth();
    const resizeObserver = new ResizeObserver(updatePageWidth);
    resizeObserver.observe(pdfContainerRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div ref={pdfContainerRef}>
      <Document
        file={pdf}
        onLoadSuccess={onDocumentLoadSuccess}
        loading={<div className='circularprocess'> <CircularProgress /></div>}
      >
        {pageWidth && Array.from(new Array(numPages), (el, index) => (
          <Page
            width={pageWidth}
            key={`page_${index + 1}`}
            pageNumber={index + 1}
            renderTextLayer={false}
            loading={<div className='circularprocess'> <CircularProgress /></div>}
          />
        ))}
      </Document>
    </div>
  );
}


